import {
  GET_BOOK_COVER,
  GET_COVER_MARGINS,
  GET_COVER_SIZES,
  LOAD_BOOK_COVER_BY_BOOK_ID,
  UPDATE_COVER_SIZE,
  UPDATE_COVER_MARGIN_SIZE } from './../../action-types/bookproperties';

export const STATE_KEY = 'cover';

export const cover = (state = {
  label: '',
  type: '',
  margins: {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
}, action) => {
  switch (action.type) {
    case GET_BOOK_COVER: {
      const { cover, margins } = action;
      return Object.assign({}, state, { margins }, cover);
    }

    case GET_COVER_MARGINS: {
      const { margins } = action;
      return Object.assign({}, state, { margins });
    }

    case GET_COVER_SIZES: {
      const {
        width,
        height,
        widthInPx,
        heightInPx,
      } = action;

      return Object.assign({}, state, {
        coverSizes: {
          width,
          height,
          widthInPx,
          heightInPx,
        },
      });
    }

    case LOAD_BOOK_COVER_BY_BOOK_ID: {
      return Object.assign({}, state, action.bookState);
    }

    case UPDATE_COVER_SIZE: {
      const {
        width,
        height,
        widthInPx,
        heightInPx,
      } = action;

      return Object.assign({}, state, {
        coverSizes: {
          width,
          height,
          widthInPx,
          heightInPx,
        },
      });
    }

    case UPDATE_COVER_MARGIN_SIZE: {
      const { marginSize } = action;

      const {
        left,
        right,
        bottom,
        top,
      } = marginSize;

      return Object.assign({}, state, {
        margins: {
          top,
          right,
          bottom,
          left,
        },
      });
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/cover.js